import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../config/api';
import './SignupPage.css';

function SignupStep2() {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    userId: '',
    password: '',
    passwordConfirm: '',
    email: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 1단계에서 전달받은 데이터 확인
  useEffect(() => {
    if (!location.state || !location.state.userName || !location.state.jumin1 || !location.state.jumin2) {
      alert('잘못된 접근입니다. 처음부터 다시 시작해주세요.');
      navigate('/signup');
    }
  }, [location, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // 에러 메시지 제거
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 클라이언트 측 유효성 검사
    const newErrors = {};

    // 아이디 검증
    if (!formData.userId || formData.userId.length < 4) {
      newErrors.userId = '아이디는 4자 이상이어야 합니다.';
    } else if (!/^[a-zA-Z0-9_]+$/.test(formData.userId)) {
      newErrors.userId = '아이디는 영문, 숫자, 언더스코어(_)만 사용 가능합니다.';
    }

    // 비밀번호 검증
    if (!formData.password || formData.password.length < 6) {
      newErrors.password = '비밀번호는 6자 이상이어야 합니다.';
    } else if (!/(?=.*[a-zA-Z])(?=.*[0-9])/.test(formData.password)) {
      newErrors.password = '비밀번호는 영문과 숫자를 모두 포함해야 합니다.';
    }

    if (formData.password !== formData.passwordConfirm) {
      newErrors.passwordConfirm = '비밀번호가 일치하지 않습니다.';
    }

    // 이메일 검증
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = '올바른 이메일 주소를 입력하세요.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userId: formData.userId,
          password: formData.password,
          userName: location.state.userName,
          email: formData.email,
          jumin1: location.state.jumin1,
          jumin2: location.state.jumin2
        })
      });

      const data = await response.json();

      if (response.ok) {
        alert('회원가입이 완료되었습니다.');
        navigate('/login');
      } else {
        if (data.error === 'DUPLICATE_USER_ID') {
          setErrors({ userId: '이미 사용 중인 아이디입니다.' });
        } else if (data.error === 'DUPLICATE_EMAIL') {
          setErrors({ email: '이미 사용 중인 이메일입니다.' });
        } else {
          alert(data.error || '회원가입에 실패했습니다.');
        }
      }
    } catch (error) {
      console.error('Signup error:', error);
      alert('회원가입 중 오류가 발생했습니다.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="signup-page">
      <div className="signup-container">
        <h1>회원가입 (2/2)</h1>
        <p className="step-description">계정 정보를 입력해주세요.</p>

        <form onSubmit={handleSubmit} className="signup-form">
          <div className="form-group">
            <label htmlFor="userId">아이디 *</label>
            <input
              type="text"
              id="userId"
              name="userId"
              value={formData.userId}
              onChange={handleChange}
              placeholder="4자 이상 (영문, 숫자, _만 사용 가능)"
              required
            />
            {errors.userId && <span className="error-message">{errors.userId}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="password">비밀번호 *</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="6자 이상 (영문+숫자 조합)"
              required
            />
            {errors.password && <span className="error-message">{errors.password}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="passwordConfirm">비밀번호 확인 *</label>
            <input
              type="password"
              id="passwordConfirm"
              name="passwordConfirm"
              value={formData.passwordConfirm}
              onChange={handleChange}
              placeholder="비밀번호 재입력"
              required
            />
            {errors.passwordConfirm && <span className="error-message">{errors.passwordConfirm}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="email">이메일 *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="example@email.com"
              required
            />
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>

          <div className="button-group">
            <button type="submit" className="submit-button" disabled={isSubmitting}>
              {isSubmitting ? '가입 중...' : '회원가입 완료'}
            </button>
            <button type="button" className="cancel-button" onClick={() => navigate('/signup')}>
              이전 단계
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SignupStep2;
